export default "__VITE_ASSET__matbIlkf__"